import { Common, ApiBind } from './common.model';

export class PlacementRelationOsGroup extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'os_group_id' })
  osGroupId: number;
}
